import useProperty from '@/hooks/useProperty';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from '@/components/shared/Button';
import Card from '@/components/shared/Card';
import { profileSelector } from '@/store/profile/profileSlices';
import './EditPropertyNew.scss';
import { useCollapsibleSections } from '@/hooks/useCollapsibleSections';
import PropertyOverview from '@/components/dashboard/Property/PropertyOverview';
import PropertyPageHeader from '@/components/dashboard/Property/PropertyPageHeader';
import EditPropertyInformation from '@/components/dashboard/PropertyEdit/EditPropertyInformation';
import EditPropertyUnitsImport from '@/components/dashboard/PropertyEdit/EditPropertyUnitsImport';
import AddUnitFormSection from '@/components/dashboard/AddUnit/AddUnitFormSection';

const baseClass = 'EditPropertyNew';

const EditPropertyNew = () => {
  const navigate = useNavigate();
  const profile = useSelector(profileSelector);

  const { property, propertyId, isLoading, isFetching } = useProperty();

  const { getSectionState, toggleSection } = useCollapsibleSections(
    'edit-property-page',
    {
      overview: false,
      information: false,
      unitsImport: false,
      addUnit: false,
    },
  );

  if (!propertyId || (!(isLoading || isFetching) && !property)) {
    return (
      <Card className={baseClass}>
        <h4>Invalid property ID</h4>
        <Button onClick={() => navigate('/properties')}>
          Go back to properties
        </Button>
      </Card>
    );
  }

  const handleUnitsImported = (units: any[]) => {
    console.log('Units imported:', units);
    // TODO: Обробити імпортовані юніти
  };

  const handleUnitsAdded = (addedUnits: any[]) => {
    console.log('Units added:', addedUnits);
    // TODO: Обробити додані юніти, можливо оновити список
  };

  return (
    <div className={baseClass}>
      <PropertyPageHeader
        property={property}
        propertyId={propertyId}
        loading={isLoading || isFetching}
        showEditButton={false}
      />

      <PropertyOverview
        property={property}
        loading={isLoading || isFetching}
        collapsed={getSectionState('overview')}
        onToggleCollapse={() => toggleSection('overview')}
        showMap={true}
      />

      <EditPropertyInformation
        property={property}
        loading={isLoading || isFetching}
        collapsed={getSectionState('information')}
        onToggleCollapse={() => toggleSection('information')}
      />



      <AddUnitFormSection
        propertyId={propertyId}
        collapsed={getSectionState('addUnit')}
        onToggleCollapse={() => toggleSection('addUnit')}
        onUnitsAdded={handleUnitsAdded}
      />
      <EditPropertyUnitsImport
        property={property}
        loading={isLoading || isFetching}
        collapsed={getSectionState('unitsImport')}
        onToggleCollapse={() => toggleSection('unitsImport')}
        onUnitsImported={handleUnitsImported}
      />
    </div>
  );
};

export default EditPropertyNew;